import { unwrapResult } from '~/modules/query/base';
import { notificationApi } from '~/modules/query/notification';
import type { SendMessageRequest, SendMessageResponse } from '~/modules/query/notification/types';

export const messagesApi = notificationApi.injectEndpoints({
  endpoints: (builder) => ({
    sendMessage: builder.mutation<SendMessageResponse, SendMessageRequest>({
      query: (data) => ({ url: '/messages', method: 'POST', data }),
      transformResponse: unwrapResult<SendMessageResponse>,
    }),
  }),
});

export const { useSendMessageMutation } = messagesApi;
